import React, { FC } from 'react';
import { AppWrapperWithPageLayout } from '../../app/common-app/AppWrapperWithPageLayout';
import { ReportTimeSystemEntity } from '../../report-time-system/ReportTimeSystemEntity';
import { LawFirmLayout } from './LawFirmLayout';
import { LawFirmMain } from './LawFirmMain';
import { LawFirmProvider } from './LawFirmContext';
import { PageNavProvider } from '../../components/page-nav/PageNavContext';
import { lawFirmNav } from './lawFirmNav';
import { LawFirmSubHeader } from './sub-header/LawFirmSubHeader';
import { EntityBreadcrumbsContainer } from '../../entity/breadcrumbs-container/EntityBreadcrumbsContainer';
import { Breadcrumb } from '../../components/breadcrumb/Breadcrumb';
import { CustomWindow } from './lawFirm.types';

declare let window: CustomWindow;

type Props = {
  readKey: string;
};

export const LawFirmApp: FC<Props> = ({ readKey }) => (
  <AppWrapperWithPageLayout subHeader={<LawFirmSubHeader />}>
    <ReportTimeSystemEntity entityType="lawFirm" readKey={readKey}>
      <LawFirmProvider>
        <PageNavProvider outline={lawFirmNav}>
          <LawFirmLayout>
            <LawFirmMain />
          </LawFirmLayout>
        </PageNavProvider>
      </LawFirmProvider>
    </ReportTimeSystemEntity>
    <EntityBreadcrumbsContainer>
      <Breadcrumb breadcrumbs={window.breadcrumbs} />
    </EntityBreadcrumbsContainer>
  </AppWrapperWithPageLayout>
);
